import { get } from 'app/utils/lo/lo';

/**
 * Resolves a user reference by ID from the loaded userReferences list.
 * If references aren't loaded yet, triggers a fetch.
 * If references are loaded but the user isn't found, returns an "Inactive user" placeholder.
 */
export const resolveUserReference = ({ entityId, userReferences, userReferencesLoading, loadUserReferences }) => {
    const id = get(entityId, 'id') || entityId;
    const user = (userReferences || []).find(usr => usr.id === id);
    if (!user && !userReferencesLoading && !userReferences?.length) {
        loadUserReferences();
    }
    if (!user && userReferences?.length) {
        return { id, name: 'Inactive user' };
    }
    return user;
};
